export const UserEmailVerificationConstants = {
    SUCCESSFUL_RESEND_MESSAGE: 'Verification email sent successfully.',
} as const;
